export interface TableSearchDataIntegrationProps {
  setTableFilter: any;
  placeholder: string;
  setCurrentPage: any;
}

export interface TableFilterStateDataIntegrationProps {
  startPeriod?: Date;
  lastPeriod?: Date;
  search?: string;
  status?: string;
}

export const StatusDataIntegrationFilter: any = [
  {
    value: "Ordem de Compra Inválida",
    key: "HEALTH_OPERATOR_INCORRECT_BUY_ORDER,HEALTH_OPERATOR_WITHOUT_BUY_ORDER",
  },
  {
    value: "Sem Produto",
    key: "HEALTH_OPERATOR_WITHOUT_PRODUCT"
  },
  {
    value: "Pendente Pesquisa",
    key: "PENDING_SEARCH"
  },
  {
    value: "Pendente Envio Nota Fiscal",
    key: "PENDING_SEND_INVOICE"
  },
  {
    value: "Nota Fiscal Enviada",
    key: "SENT_INVOICE"
  },
  {
    value: "Erro Envio Nota Fiscal",
    key: "ERROR_SENT_INVOICE"
  },
  {
    value: "Erro Envio Comprovante",
    key: "ERROR_SENT_RECEIPT"
  },
  {
    value: "Pendente Envio Comprovante",
    key: "PENDING_RECEIPT"
  },
  {
    value: "Necessário Ação Manual",
    key: "MANUAL_ACTION_REQUIRED"
  },
  {
    value: "Comprovante Enviado",
    key: "SENT_RECEIPT"
  },
  {
    value: "Finalizado",
    key: "FINISHED"
  }];

export const StatusErrorSelectedIntegration: any = [
  "HEALTH_OPERATOR_INCORRECT_BUY_ORDER,HEALTH_OPERATOR_WITHOUT_BUY_ORDER",

  "HEALTH_OPERATOR_WITHOUT_PRODUCT",

  "ERROR_SENT_INVOICE",

  "ERROR_SENT_RECEIPT",

  "MANUAL_ACTION_REQUIRED"
];

export const StatusErrorSearchIntegration: string = "HEALTH_OPERATOR_INCORRECT_BUY_ORDER,HEALTH_OPERATOR_WITHOUT_BUY_ORDER,HEALTH_OPERATOR_WITHOUT_PRODUCT,ERROR_SENT_INVOICE,ERROR_SENT_RECEIPT,MANUAL_ACTION_REQUIRED";